const redirectIfFromAbroad = () => {
  const localization = window.shopifyLocalization;
  if (localization.countryCode === 'BR' || localization.countryCode === 'PT') {
      if (!window.location.href.includes('.es/pt')) {
          // commenting this until new domain comes
          // window.location.href = 'https://enamoradadelmuro.es/pt';
      }
  }
};

redirectIfFromAbroad();
